import React, { useState } from 'react';

import styles from './overflowMenu.less';
import 'vxpattern-lib-paypal/dist/components/overflow-menu/overflow-menu.js';
import { trackLink } from '../../lib/analytics';
import {
  SET_PREFERRED_PAGE_GROUP,
  SET_PREFERRED_PAGE_LANDING,
} from '../../lib/fptiTrackingVariables';
import { OverflowMenu as PPOverFlowMneu } from '@paypalcorp/pp-react';

export const OVERFLOW_OPTIONS = {
  MORE_INFO: 'MORE_INFO',
  SET_FAVORITE: 'SET_FAVORITE',
};

const OverflowMenu = React.memo(
  ({ hubFlow, fptiInfo, options, onOptionChanged, name }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const buttonStyle = hubFlow
      ? styles.hubOverflowMenuBtn
      : styles.setFavOverflowMenuBtn;
    const overFlowMenuStyle = hubFlow
      ? styles.hubOverFlowMenu
      : styles.setFavOverflowMenu;

    const onOverflowMenuClicked = (e) => {
      e.stopPropagation();
      setMenuIsOpen(!menuIsOpen);
      trackLink(
        'more',
        hubFlow ? fptiInfo.pgrp : SET_PREFERRED_PAGE_GROUP,
        hubFlow ? fptiInfo.page : SET_PREFERRED_PAGE_LANDING,
        'link'
      );
    };

    return (
      <PPOverFlowMneu
        className={`${buttonStyle} ${overFlowMenuStyle}`}
        name={name}
        theme='v2'
        aria-label='Menu'
        data-nemo='overflow-menu'
        onOpen={onOverflowMenuClicked}
        onClose={onOverflowMenuClicked}
        onChange={(e) => {
          onOptionChanged(e.target.value);
        }}
        isOpen={menuIsOpen}
        options={[...options]}
      />
    );
  }
);

export default OverflowMenu;
